module.exports = __webpack_public_path__ + "img/icon_help.4b6de4e9.svg";